/**
 * Store Équipes
 */
export default {
    state: {
        lieuxProductions: []
    },

    mutations: {
        /**
         * Initialise le state lieuxProductions
         */
        setLieuxProductions: function (state, lieuxProductions) {
            state.lieuxProductions = lieuxProductions
        }
    },

    getters: {
        /**
         * Liste d'options de lieux de productions
         */
        optionsLieuxProductions: state => {
            return state.lieuxProductions
                .filter(lieu => lieu.is_actif)
                .map(lieu => ({label: lieu.nom, value: lieu.id}))
        }
    }
}
